import React from 'react';
import {TableCell} from "../../../../core/components/table/table-cell";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {Link} from "../../../../core/components/link/link";
import {EntityLogo} from "../../../../core/components/logos/entity-logo";
import {CompetitorViewModel} from "../../../../domain/common/competitor/models/competitor-view-model";
import {TOOLTIP_PLACEMENT} from "../../../../core/components/tooltip/tooltip-consts";
import {Tooltip} from "../../../../core/components/tooltip/tooltip";
import {GameBadgeTooltipContent} from "../../../../core/components/game-badge/game-badge-tooltip/game-badge.tooltip-content";
import {STANDINGS_WIDGET} from "../../standings-widget.consts";
import type {StandingsWidgetNextMatchModel} from "../../models/standings-widget.next-match.model";
import type {CompetitionGamesDomainModel} from "../../../../domain/common/competition-games.domain-model";

export const StandingsWidgetTableNextMatchCell = ({cell, controller, competitor}) => {
  if(!cell?.value) {
    return <TableCell className={classNames(styles.table_no_next_match_cell)}>-</TableCell>
  }

  const game: StandingsWidgetNextMatchModel = cell.value;
  const nextOpponent: CompetitionGamesDomainModel = game.homeCompetitor.id !== competitor.id ? game.homeCompetitor : game.awayCompetitor

  const onMouseEnter = () => controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeHighlightedRows, {hoveredCompetitorIds: [game.homeCompetitor.id, game.awayCompetitor.id]});
  const onMouseLeave = () => controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeHighlightedRows, {hoveredCompetitorIds: []});

  const tooltipProps = {
    className: classNames(styles.table_row_badge_tooltip),
    placement: TOOLTIP_PLACEMENT.bottom,
    content: <GameBadgeTooltipContent game={game}/>,
  }

  const linkProps = {
    model: game.linkModel,
    onMouseEnter,
    onMouseLeave
  }

  const entityLogoProps = {
    entity: new CompetitorViewModel(nextOpponent),
    className: classNames(styles.table_row_next_competitor),
    width: STANDINGS_WIDGET.ICONS.NEXT_OPPONENT.size,
    height: STANDINGS_WIDGET.ICONS.NEXT_OPPONENT.size,
  }

  return (
    <TableCell className={classNames(styles.table_text_cell)}>
      <Tooltip {...tooltipProps}>
        <Link {...linkProps}>
          <EntityLogo {...entityLogoProps}/>
        </Link>
      </Tooltip>
    </TableCell>
  )
}
